import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../utils/AuthContext';

export default function ResetPassword() {
    const { resetPassword } = useAuth();

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');

    // get token from URL
    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setError('Invalid or missing password reset token.  Please contact your administrator');
            return;
        }
        setToken(token);
    }, [searchParams])

    const handleSubmit = async(event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            const data = await resetPassword(token, password);
            setMessage(data.message);

            setTimeout(() => {
                navigate('/login');
            }, 2000)
        } catch {
            setError('Error resetting password - please try again')
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100'>

            {/* reset pw card  */}
            <div className='flex justify-center items-center px-6 py-24'>
                <div className='w-full max-w-md p-10 rounded-xl shadow-2xl bg-white/90 backdrop-blur-md'>
                    <h3 className='text-3xl font-bold text-docpgrPurple mb-8 text-center'>reset your password</h3>

                    {error && <p className='mb-4 text-red-600 text-center bg-red-50 p-2 rounded'>{error}</p>}
                    {message && <p className='mb-4 text-green-600 text-center bg-green-50 p-2 rounded'> {message}</p>}

                    {!message && (
                        <form onSubmit={handleSubmit} className='space-y-6'>
                            <div>
                                <label className='block text-sm font-medium text-gray-700 mb-1'>new password</label>
                                <input type='password' required value={password} onChange={(event) => setPassword(event.target.value)} className='w-full p-3 rounded-md border border-gray text-lg focus:outline-none focus:ring-2 focus:ring-docpgrPurple focus:border-docpgrPurple' placeholder='enter a strong password' />
                            </div>
                            <button type='submit' disabled={loading || error} className='w-full px-6 py-3 mt-4 rounded-lg text-white font-bold voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow disabled:bg-docpgrPurple60 transition'>
                                {loading ? "resetting..." : "reset password"}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    )
}